import { useLocation } from 'react-router';
import { downloadIcs, type IcsEvent } from '../../shared/ics';
import { whatsappShare } from '../../shared/whatsapp';
import { formatWhen } from './shared';

/** «Agregar a mi calendario» (.ics) y «Compartir por WhatsApp» en las páginas públicas de evento y reunión. */
export function CalendarShareButtons({ event }: { event: IcsEvent & { startsAt: string; endsAt: string } }) {
  const { pathname } = useLocation();
  const url = event.url ?? `${window.location.origin}${pathname}`;
  const text = `${event.title}\n${formatWhen(event.startsAt, event.endsAt)}\n${url}`;
  return (
    <div className="actions actions--wrap">
      <button type="button" className="btn btn--primary" onClick={() => downloadIcs({ ...event, url })}>
        Agregar a mi calendario
      </button>
      <a className="btn btn--secondary" href={whatsappShare(text)} target="_blank" rel="noopener noreferrer">
        Compartir por WhatsApp
      </a>
    </div>
  );
}
